import { imgBackgroundAbout } from "../../../shared/assets/img/index";

export const about = {
    img: imgBackgroundAbout,
};
